<header class="header navbar" [ngClass]="{'navbar-fixed': isFixedNavbar}">
    <div class="container">
        <div class="bl-row">
            <div class="logo">
                <a href="https://wearenovae.com/"><img class="logo-novae" src="./assets/img/logo-gennius.svg" alt="logo-novae"></a>
                <img class="element-header" src="./assets/img/cryptmi/logo-gennius.svg" alt="logo-novae">
            </div>
            <div class="navbar-mobile-top" fxLayout="row" fxLayoutWrap="wrap" fxLayoutAlign="start center">
                <div color="accent" class="navbar-toggle" (click)="toggleNavbar()">
                    <mat-icon class="icono-animacion" [ngClass]="navbarOpened ? 'mostrar' : 'oculto'"></mat-icon>
                </div>
            </div>
            <div  fxFlex class="top-navbar">
                <ul>
                    <li><a href="https://wearenovae.com/">CryptMi App</a></li>
                    <li><a href="https://wearenovae.com/co-creation/">CryptMi Card</a> </li>
                    <li><a href="https://wearenovae.com/miles/">My lifestyle</a> </li>
                    <li class="connect"><a href="https://wearenovae.com/miles/"><span>Connect</span></a> </li>
                </ul>
            </div>
            <nav class="menu">
                <ul class="menu-list">
                    <li><a href="https://wearenovae.com/">Home</a>   </li>
                    <li><a href="https://wearenovae.com/co-creation/">Co-Creation</a> </li>
                    <li><a href="https://wearenovae.com/miles/">Miles Card</a> </li>
                    <li class="active"><a class="text-decoration" href="#">Miles Care</a> </li>
                    <li><a href="https://wearenovae.com/miles-mercy/">Miles for Mercy</a> </li>
                    <li><a href="https://wearenovae.com/about/">About</a> </li>
                    <li><a href="https://wearenovae.com/press/">Press</a> </li>
                </ul>
            <img class="element-2" src="./assets/img/element-intro2.svg" alt="logo-novae">
            <img class="element-1" src="./assets/img/element-intro.svg" alt="logo-novae">
            </nav>
        </div>
    </div>
</header>
<!-- Main -->
